import { useEffect } from 'react'
import { NavigateFunction } from 'react-router-dom'
import useStore from 'stores/utils/hooks/useStore'

const useAutoProceedAfter = (
  proceedAfter: number,
  navigate: NavigateFunction
) => {
  const {
    navigation: { goToNextPage }
  } = useStore()

  useEffect(() => {
    const timeout = setTimeout(async () => {
      await goToNextPage(navigate)
    }, proceedAfter)

    return () => {
      clearTimeout(timeout)
    }
  }, [goToNextPage, proceedAfter, navigate])
}

export const useAutoProceedPage = (
  proceedAfter: number,
  navigate: NavigateFunction
) => {
  useAutoProceedAfter(proceedAfter, navigate)
}
